import { useDispatch } from "react-redux";
import { HashRouter as Router, Route, Routes } from "react-router-dom"; //Navigate,
import GlobalStyle from "GlobalStyle";

import OrganismWatcher from "Components/Organisms/Watcher";
import OrganismInit from "Components/Organisms/Init";
import PageStep1 from "Components/Pages/Step1";
import PageStep2 from "Components/Pages/Step2";
import PageStep3 from "Components/Pages/Step3";
import PageStep4 from "Components/Pages/Step4";
import PageStep5 from "Components/Pages/Step5";
import PageSuccess from "Components/Pages/Success";

import * as actions from "actions";

function ComRoutes() {
   const dispatch = useDispatch();

   function onResize() {
      dispatch({
         type: actions.dimensions.sync,
         payload: {
            width: window.innerWidth,
            height: window.innerHeight,
         },
      });
   }

   window.addEventListener("resize", onResize);

   return (
      <Router>
         <>
            <GlobalStyle></GlobalStyle>
            <OrganismWatcher></OrganismWatcher>
            <OrganismInit></OrganismInit>
            <Routes>
               <Route path="/steps/1" element={<PageStep1 />} />
               <Route path="/steps/2" element={<PageStep2 />} />
               <Route path="/steps/3" element={<PageStep3 />} />
               <Route path="/steps/4" element={<PageStep4 />} />
               <Route path="/steps/5" element={<PageStep5 />} />
               <Route path="/steps" element={<PageStep1 />} />
               <Route path="/success" element={<PageSuccess />} />
               <Route path="/success" element={<PageSuccess />} />

               <Route path="/" element={<PageStep1 />} />
               <Route path="*" element={<PageStep1 />} />
            </Routes>
         </>
      </Router>
   );
}

export default ComRoutes;
